import { Api, queryKeys } from '@/infrastructure';
import { ScheduleAdjustment, ScheduleAdjustmentCalendar, ScheduleAdjustmentTimeframe } from '@/types';
import { UseQueryResult } from 'react-query';
import { useQueryWrapper } from '../useQueryWrapper';

export const useDirectScheduleAdjustmentQuery = (token: string): UseQueryResult<ScheduleAdjustment> => {
  return useQueryWrapper<ScheduleAdjustment>({
    queryKey: queryKeys.directScheduleAdjustment,
    req: () => Api.get({ path: `direct_schedule_adjustments/${token}` }),
    deps: [token],
    options: { enabled: !!token, retryOnMount: false, refetchOnReconnect: false }
  });
};

export const useDirectScheduleAdjustmentCalendarQuery = ({
  orderId,
  token,
  startDate
}: {
  orderId: number;
  token: string;
  startDate: string;
}): UseQueryResult<ScheduleAdjustmentCalendar> => {
  return useQueryWrapper<ScheduleAdjustmentCalendar>({
    queryKey: queryKeys.directScheduleAdjustmentCalendar,
    req: () =>
      Api.get({ path: `direct_schedule_adjustments/${token}/orders/${orderId}/calendars?start_date=${startDate}` }),
    deps: [token, orderId, startDate],
    options: {
      enabled: !!orderId && !!token && !!startDate,
      staleTime: 0
    }
  });
};

export const useDirectScheduleAdjustmentTimeframeQuery = ({
  orderId,
  token,
  month
}: {
  orderId: number;
  token: string;
  month: string;
}): UseQueryResult<ScheduleAdjustmentTimeframe> => {
  return useQueryWrapper<ScheduleAdjustmentTimeframe>({
    queryKey: queryKeys.directScheduleAdjustmentTimeframe,
    req: () => Api.get({ path: `direct_schedule_adjustments/${token}/orders/${orderId}/timeframes?month=${month}` }),
    deps: [token, orderId, month],
    options: {
      enabled: !!orderId && !!token && !!month,
      staleTime: 0
    }
  });
};
